import axios from "axios";
import httpConfig from "../baseConfig/httpConfig";
import tools from "../utils/fun";
import md5 from 'js-md5';

const codeMessage = {
    200: "success",
};

/**
 * 校验url地址
 * @param {*} url  
 */
const getFullUrl = (url) => {
    if (/http(s)?:\/\//.test(url)) {
        return url;
    }
    url.startsWith("/") && (url = url.substring(1, url.length));
    let newUrl = httpConfig.baseUrl();
    !newUrl.endsWith("/") && (newUrl += "/"); 
    newUrl += httpConfig.prefix + url;
    return newUrl;
}

const checkStatus = response => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const errortext = codeMessage[response.status] || response.statusText;
    const error = new Error(errortext);
    error.name = response.status;
    error.response = response;
    throw error;
};


/**
 * 获得url参数拼接串
 * @param {*} url 
 */
const getRawSignStr = (url) => {
    var theRequest = new Object();
    var strs;
    var keys = [];
    var rawSignstr = "";
    if (url.indexOf("?") != -1) {
        var str = url.substr(url.indexOf("?") + 1);
        strs = str.split("&");
        var key = null;
        for (var i = 0; i < strs.length; i++) {
            key = strs[i].split("=")[0];
            theRequest[key] = unescape(strs[i].split("=")[1]);
            keys.push(key);
        }
        keys = keys.sort();
        for (var j = 0; j < keys.length; j++) {
            rawSignstr += keys[j] + theRequest[keys[j]];
        }
    }
    return rawSignstr;
}

/**
 * 跳转登录界面，或者关闭当前界面
 * @param {*} self 
 */
const toLogin = (self) => {
    if (window.parent && window.parent.window) {
        let win = window.parent.window;
        if (typeof win['closeUi'] == 'function') {
            win['closeUi']();
            return;
        }
    }
    //跳转登录界面
    tools.toPage(self, { path: '/' , query:{ action:"login" } } , true);
}


/**
 * 签名API v 1.0 (早期几个接口用到)
 * @param {*} method 
 * @param {*} url 
 * @param {*} params 
 * @param {*} timeout 
 */
export function signAction(self, method, url, params, timeout , isRetry) {
    let login = tools.getLoginToken(self);
    if (!login.isLogin) {
        toLogin(self);
        return;
    }
    //签名
    let rawSignstr = getRawSignStr(url);
    let sign = md5(rawSignstr + login.token + login.secretKey).toString();
    //设置参数与header
    const options = {
        method: method,
        data: params ? JSON.stringify(params) : null,
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "token": login.token,
            "time": new Date().getTime(),
            "r": sign
        },
        url: getFullUrl(url),
        timeout: timeout || httpConfig.defaultTimeout
    };
    return request(options, self, isRetry);
}

/**
 * 签名API v 2.0 添加游客账号的判断
 * @param {*} self 
 * @param {*} method 
 * @param {*} url 
 * @param {*} params 
 * @param {*} newData 
 * @param {*} timeout 
 */
export function signActionTimeByGuest(self, method, url, params, newData, timeout , isRetry) {
    //签名
    let d = ""
    if (typeof params == "string") {
        d = params;
    } else {
        d = params != "" ? JSON.stringify(params) : "";
    }

    let login = tools.getLoginToken(self);
    let token = login.token;
    let scret = login.secretKey;
    //游戏进入 demo模式的非登录账号才能正常校验
    if (!login.isLogin && login.isDemo) {
        token = login.demoToken;
        scret = login.demoSecretKey;
    }
    let time = new Date().getTime().toString();
    let bodyMd5 = md5(d).toString();
    let sign = md5(token + scret + time + newData.urlStr + bodyMd5).toString();
    //设置参数与header
    const options = {
        method: method,
        data: d,
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "token": token,
            "time": time,
            "r": sign,
        },
        url: getFullUrl(url),
        timeout: timeout || httpConfig.defaultTimeout
    };
    return request(options, self, isRetry);
}

/**
 * 签名API v 2.0
 * @param {*} self 
 * @param {*} method 
 * @param {*} url 
 * @param {*} params 
 * @param {*} newData 
 * @param {*} timeout 
 */
export function signActionTime(self, method, url, params, newData, timeout , isRetry) {
    let login = tools.getLoginToken(self);
    if (!login.isLogin) {
        toLogin(self);
        return;
    }
    //签名
    let d = ""
    if (typeof params == "string") {
        d = params;
    } else {
        d = params != "" ? JSON.stringify(params) : "";
    }

    let time = new Date().getTime().toString();
    let bodyMd5 = md5(d).toString();
    let sign = md5(login.token + login.secretKey + time + newData.urlStr + bodyMd5).toString();
    //设置参数与header
    const options = {
        method: method,
        data: d,
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "token": login.token,
            "time": time,
            "r": sign,
        },
        url: getFullUrl(url),
        timeout: timeout || httpConfig.defaultTimeout
    };
    return request(options, self, isRetry);
}

/**
 * 数据流输入
 * @param {*} url 
 * @param {*} data 
 */
export function noSignActionBody(url, data) {
    return axios.post(url, data  , {headers: {'Content-Type': 'application/json;charset=UTF-8'}});
}

/**
 * 不签名
 * @param {方法类型} method 
 * @param {请求地址：可以给相对地址} url 
 * @param {参数} params 
 * @param {过期时间} timeout 
 */
export function noSignAction(method, url, params, timeout , isRetry) {
    const options = {
        method: method,
        data: JSON.stringify(params),
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        },
        url: getFullUrl(url),
        timeout: timeout || httpConfig.defaultTimeout
    };
    return request(options, null, isRetry);
}

/**
 * 重试逻辑管理，链接失败，可重试三次
 * @param {*} url 
 */

const clearRetryApi = function(url){
    if (window.requesAction && window.requesAction[url]) {
        window.requesAction[url] = 0;
        delete window.requesAction[url];
    }
};

const checkRetryApi = function(url){
    if (!window.requesAction) {
        window.requesAction = {};
    }

    if (!window.requesAction[url]) {
        window.requesAction[url] = 0;
    }
    window.requesAction[url]++;
    if (window.requesAction[url] <= 3) {
        return true;
    } else {
        clearRetryApi(url);
        return false;
    }    
};

/**
 * 结果返回错误，是否需要重试
 * @param {*} data 
 * @param {*} url 
 * @param {*} isRetry 
 */
const checkRetryRequest = function(data , url, isRetry){
    let isNeed = false;
    if (!isRetry) {
        clearRetryApi(url);
    } else {
        if (data && data.hasOwnProperty("result")) {
            if (data.result != 1) {
                isNeed = checkRetryApi(url);
            }
        }
        if (!isNeed) {
            clearRetryApi(url);
        }
    }
    return isNeed;
}

/**
 * 执行请求
 * @param {*} option 
 */
const request = (option, self, isRetry) => {
    const options = {
        ...option
    };
    const defaultOptions = {};
    const newOptions = { ...defaultOptions, ...options };
    return (
        axios
            .request(newOptions)
            .then(checkStatus)
            .then(response => {
                if (checkRetryRequest(response.data , option.url, isRetry)) {
                    return request(option, self , isRetry);
                } else {
                    return response.data;
                }
            })
            .catch(error => {                
                console.log("request error = ", error);
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log("error.response.data = ", error.response.data);
                    console.log("error.response.status = ", error.response.status);
                    console.log("error.response.headers = ", error.response.headers);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log("error.request = ", error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log("error.message = ", error.message);
                }
                console.log("error.config = ", error.config);
                //如果链接执行错误，重新执行三次
                if (checkRetryApi(option.url)) {
                    return request(option, self , isRetry);
                }
            })
    );
}

/**
 * 更早期cocos 版本 小游戏 签名API 
 * @param {*} self 
 * @param {*} method 
 * @param {*} url 
 * @param {*} params 
 * @param {*} timeout 
 * @param {*} callback 
 * @param {*} errback 
 * @param {*} isForce 
 */
export function signUserAction(self, method, url, params, timeout, callback, errback, isForce = false) {
    let login = tools.getLoginToken(self);
    if (!login.isLogin && !login.isDemo && !isForce) {
        toLogin(self);
        return;
    }
    !timeout && (timeout = httpConfig.defaultTimeout);
    let xhr = new XMLHttpRequest();
    xhr.timeout = timeout;
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            switch (xhr.status) {
                case 200:{
                    clearRetryApi(url);
                    callback(xhr.response);
                    break;
                }
                default:{
                    //如果链接执行错误，重新执行三次
                    if (checkRetryApi(url)) {
                        setTimeout(() => {
                            signUserAction(self, method, url, params, timeout, callback, errback);
                        }, 500);
                    } else {
                        errback(this._obj, xhr.response);
                    }
                    break;
                }
            }
        }
    }.bind(this);
    xhr.open(method, getFullUrl(url), true);

    let token = login.token;
    let scret = login.secretKey;
    if (!login.isLogin && login.isDemo) {
        token = login.demoToken;
        scret = login.demoSecretKey;
    }
    //签名
    let rawSignstr = getRawSignStr(url);
    let sign = md5(rawSignstr + token + scret).toString();
    xhr.setRequestHeader("token", token);
    xhr.setRequestHeader("time", new Date().getTime());
    xhr.setRequestHeader("r", sign);
    xhr.send(params);
}


/**
 * 更早期cocos 版本 小游戏 非签名API 
 * @param {*} self 
 * @param {*} method 
 * @param {*} url 
 * @param {*} params 
 * @param {*} timeout 
 * @param {*} callback 
 * @param {*} errback 
 */
export function unsignUserAction(self, method, url, params, timeout, callback, errback) {
    !timeout && (timeout = httpConfig.defaultTimeout);
    let xhr = new XMLHttpRequest();
    xhr.timeout = timeout;
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            switch (xhr.status) {
                case 200:{
                    clearRetryApi(url);
                    callback(xhr.response);
                    break;
                }
                default:{
                    //如果链接执行错误，重新执行三次
                    if (checkRetryApi(url)) {
                        setTimeout(() => {
                            signUserAction(self, method, url, params, timeout, callback, errback);
                        }, 500);
                    } else {
                        errback(this._obj, xhr.response);
                    }
                    break;
                }
            }
        }
    }.bind(this);
    xhr.open(method, getFullUrl(url), true);
    xhr.send(params);
}


// WEBPACK FOOTER //
// ./src/utils/http.js